import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const EmptyStar = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    strokeAsPrimary: true,
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        stroke={primaryColorToUse}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M12.0626 2.37195L15.1526 8.63195L22.0626 9.64195L17.0626 14.5119L18.2426 21.3919L12.0626 18.1419L5.88256 21.3919L7.06256 14.5119L2.06256 9.64195L8.97256 8.63195L12.0626 2.37195Z'
      />
    </svg>
  );
};
